import { Center, Tooltip } from "@chakra-ui/react";
import { Link } from "@components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import {
  TextEditor,
  type TextEditorRef,
} from "@src/components/ui-kit/TextEditor/TextEditor";
import { can } from "@src/utils/components/permissions";
import { WrapComponent } from "@src/utils/components/WrapComponent";
import { useRef, useState } from "react";

interface NoteProps {
  note?: string;
  id?: string;
}

export const Note = ({ note, id }: NoteProps) => {
  const editorRef = useRef<TextEditorRef>(null);
  const canUpdate = can("project_update_all") || can("project_update_own");
  const [isOpen, setIsOpen] = useState(false);

  if (!note) return null;

  return (
    <WrapComponent
      if={canUpdate}
      with={(children) => (
        <Link href={{ pathname: "/projects/edit", query: { id } }}>
          {children}
        </Link>
      )}
    >
      <Tooltip
        isOpen={isOpen}
        label={
          !!isOpen && (
            <TextEditor
              ref={editorRef}
              onChange={() => {}}
              attachments={[]}
              initialValue={note}
            />
          )
        }
        placement="bottom-end"
      >
        <Center
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <Icon name="message-text-square-01" w="6" h="6" color="grey.500" />
        </Center>
      </Tooltip>
    </WrapComponent>
  );
};
